var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "url(#paint0_linear_2137_7513)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9994 40.6401C34.9803 40.6401 40.6394 34.981 40.6394 28.0001C40.6394 21.0192 34.9803 15.3601 27.9994 15.3601C21.0185 15.3601 15.3594 21.0192 15.3594 28.0001C15.3594 34.981 21.0185 40.6401 27.9994 40.6401ZM25.2908 32.2887C24.6675 32.2887 24.1622 32.794 24.1622 33.4173C24.1622 34.0406 24.6675 34.5458 25.2908 34.5458H30.7079C31.3312 34.5458 31.8365 34.0406 31.8365 33.4173C31.8365 32.794 31.3312 32.2887 30.7079 32.2887H29.1279V27.0973C29.1279 26.474 28.6227 25.9687 27.9994 25.9687H26.1937C25.5704 25.9687 25.0651 26.474 25.0651 27.0973C25.0651 27.7205 25.5704 28.2258 26.1937 28.2258H26.8708V32.2887H25.2908ZM29.8051 22.583C29.8051 23.5802 28.9966 24.3887 27.9994 24.3887C27.0021 24.3887 26.1937 23.5802 26.1937 22.583C26.1937 21.5857 27.0021 20.7773 27.9994 20.7773C28.9966 20.7773 29.8051 21.5857 29.8051 22.583Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_7513",
    x1: -6.00482,
    y1: 61.32,
    x2: 67.2446,
    y2: 57.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.d23df387c62936d835c4364905bb1265.svg";
export { ForwardRef as ReactComponent };